import React, { Component } from "react";
import { connect } from "react-redux";
import Modal from "react-modal";
import PropTypes from "prop-types";

import {
  CloseButtonContainer,
  MainContainer,
  Header,
  ClientName,
  FeedNameAndType,
  TableContainer,
  Table,
  EmptyFilePreview
} from "./styles";

import {
  fetchFilePreview,
  RECEIVE_FILE_PREVIEW
} from "../../../../../actions/progress";

import { CloseIcon, TVAdExposureIcon } from "../../../../../icons/index";
import { formatDate } from "../../../../../utils/index";
import LoadingSpinner from "../../../../Common/LoadingSpinner";
import {
  MAIN_CONTENT_MIN_WIDTH,
  FEED_TYPE_MAPPING
} from "../../../../../constants";

const modalStyles = {
  overlay: {
    display: "flex",
    backgroundColor: "rgba(33,37,48,0.9)",
    zIndex: "1000"
  },
  content: {
    position: "static",
    margin: "auto",

    display: "flex",
    flexDirection: "column",
    fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
    width: MAIN_CONTENT_MIN_WIDTH,
    padding: 0,
    backgroundColor: "transparent",
    border: "none"
  }
};

export class FilePreviewModal extends Component {
  state = {
    rows: [],
    loading: false
  };

  sortRows = this.sortRows.bind(this);

  componentDidUpdate(prevProps) {
    const { show, file, fetchFilePreview } = this.props;
    if (prevProps.show === true && show === false) {
      // If the modal is being closed, we should reset the state
      // Can't do this on componentWillUnmount because technically the modal is always mounted
      this.setState({ rows: [], loading: false });
    }

    if (prevProps.show === false && show === true && file) {
      // If the modal is being opened, we should reset the state
      // Can't do this on componentDidMount because technically the modal is always mounted
      const { report_id, day } = file;
      this.setState({ loading: true });
      fetchFilePreview(report_id, day).then(action => {
        let rows = [];
        if (action.type === RECEIVE_FILE_PREVIEW) {
          rows = action.rows;
        }
        this.setState({ rows, loading: false });
      });
    }
  }

  sortRows() {
    // Ensure the rows are sorted by timestamp. This might not end up being
    // necessary if the rows are always ordered properly in S3 by DE. But,
    // until we can confirm this, we will continue to sort here to be sure
    return this.state.rows.sort(
      (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
    );
  }

  render() {
    const {
      show,
      shouldCloseOnOverlayClick,
      onDismiss,
      getClient,
      getFeed,
      file
    } = this.props;
    const { loading } = this.state;

    if (!file) return null;
    let feed = getFeed(file.report_id);
    let client = getClient(feed.client_id);
    const sortedRows = this.sortRows();
    return (
      <Modal
        isOpen={show}
        onRequestClose={onDismiss}
        style={modalStyles}
        ariaHideApp={false}
        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      >
        <CloseButtonContainer onClick={onDismiss}>
          <CloseIcon />
        </CloseButtonContainer>
        <MainContainer>
          <Header>
            <ClientName>{client && client.name}</ClientName>
            <FeedNameAndType>
              {`${feed.name} •`}
              <TVAdExposureIcon />
              {FEED_TYPE_MAPPING[feed.type]} File • Posted
              <span>{`${formatDate(file.created_at)}`}</span>
            </FeedNameAndType>
          </Header>
          {loading && (
            <EmptyFilePreview>
              <LoadingSpinner />
            </EmptyFilePreview>
          )}
          {sortedRows.length === 0 && !loading && (
            <EmptyFilePreview>
              This file does not have a preview at this time
            </EmptyFilePreview>
          )}
          {sortedRows.length > 0 && !loading && (
            <TableContainer>
              <Table>
                <thead>
                  <tr>
                    {Object.keys(sortedRows[0]).map(row => (
                      <th key={row}>{row}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {sortedRows.map(row => {
                    // None of the fields are strictly unique, but this
                    // combination should be unique to each row of data
                    return (
                      <tr key={row.smbaId}>
                        {Object.values(row).map(r => (
                          <td key={r}>{r}</td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </TableContainer>
          )}
        </MainContainer>
      </Modal>
    );
  }
}

FilePreviewModal.defaultProps = {
  shouldCloseOnOverlayClick: true
};

FilePreviewModal.propTypes = {
  show: PropTypes.bool,
  onDismiss: PropTypes.func,
  shouldCloseOnOverlayClick: PropTypes.bool,
  file: PropTypes.shape({
    id: PropTypes.string,
    day: PropTypes.string,
    report_id: PropTypes.number,
    progressing: PropTypes.bool,
    created_at: PropTypes.string,
    updated_at: PropTypes.string,
    row_cnt: PropTypes.string,
    device_cnt: PropTypes.string,
    title_cnt: PropTypes.string,
    network_cnt: PropTypes.string,
    airing_cnt: PropTypes.string,
    brand_cnt: PropTypes.string,
    sla_violation: PropTypes.bool
  }),
  fetchFilePreview: PropTypes.func,
  getClient: PropTypes.func,
  getFeed: PropTypes.func
};

export default connect(
  store => ({
    getClient: id => store.entities.clients.byId[id],
    getFeed: id => store.entities.feeds.byId[id]
  }),
  { fetchFilePreview }
)(FilePreviewModal);
